import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { DragSource, DropTarget } from 'react-dnd';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import {
  imageEditorPresetSource,
  imageEditorPresetTarget,
} from '../../../../../helpers/DNDImageEditorPreset';
import ItemTypes from '../../../../../helpers/DNDItemTypes';

const ItemImageEditorPresetRow = ({
  preset,
  index,
  isDragging,
  connectDragSource,
  connectDropTarget,
  onEdit,
  onDelete,
}) => {
  const intl = useIntl();

  return connectDragSource(connectDropTarget(
    <tr style={{ opacity: isDragging ? 0.4 : 1 }}>
      <td className="wrapper-drag-and-drop-icon">
        <i className="fa-solid fa-grip-vertical" />
      </td>
      <td>{preset.label}</td>
      <td>{preset.x}</td>
      <td>{preset.y}</td>
      <td className="action-more">
        <UncontrolledDropdown>
          <DropdownToggle nav className="options">
            <i className="far fa-ellipsis-h" />
          </DropdownToggle>
          <DropdownMenu right>
            <DropdownItem onClick={() => onEdit(index)}>
              <i className="fas fa-pencil" />
              {intl.formatMessage({ defaultMessage: 'Edit' })}
            </DropdownItem>
            <DropdownItem divider />
            <DropdownItem
              onClick={(e) => {
                e.preventDefault();
                onDelete(index);
              }}
            >
              <i className="fas fa-trash" />
              {intl.formatMessage({ defaultMessage: 'Delete' })}
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </td>
    </tr>,
  ));
};

ItemImageEditorPresetRow.propTypes = {
  preset: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isDragging: PropTypes.bool.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  canDrag: PropTypes.bool,
  moveImageEditorPreset: PropTypes.func.isRequired,
  saveImageEditorPresets: PropTypes.func.isRequired,
};

ItemImageEditorPresetRow.defaultProps = {
  canDrag: true,
};

export default compose(
  DragSource(ItemTypes.IMAGE_EDITOR_PRESET, imageEditorPresetSource, (c, monitor) => ({
    connectDragSource: c.dragSource(),
    isDragging: monitor.isDragging(),
  })),
  DropTarget(ItemTypes.IMAGE_EDITOR_PRESET, imageEditorPresetTarget, c => ({
    connectDropTarget: c.dropTarget(),
  })),
)(ItemImageEditorPresetRow);
